module.exports = __webpack_public_path__ + "media/components/country-flag/static/tl-5cceab003c7b8bf70136614a8f1aafbb.svg";